'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const getFlag = (resultGrade, resultGradeFlip) => {
  if (resultGradeFlip) {
    return resultGrade ? 'fail' : 'pass';
  } else {
    return resultGrade ? 'pass' : 'fail';
  }
};
const Tag = ({
  resultGrade,
  resultGradeFlip
}) => {
  const resultGradeFlag = getFlag(resultGrade, resultGradeFlip);
  return /*#__PURE__*/_jsx("div", {
    className: "tag-wrapper",
    children: /*#__PURE__*/_jsx("div", {
      className: `tag tag-${resultGradeFlag}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `results.data.${resultGradeFlag}`
      })
    })
  });
};
export default Tag;